"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcEllipsis = function ArcEllipsis(_ref) {
  var label = _ref.label,
    ellipsis = _ref.ellipsis,
    type = _ref.type,
    disabled = _ref.disabled,
    mark = _ref.mark,
    code = _ref.code,
    keyboard = _ref.keyboard,
    underline = _ref.underline,
    strong = _ref.strong,
    italic = _ref.italic,
    deletep = _ref.deletep,
    editable = _ref.editable,
    copyable = _ref.copyable,
    expandable = _ref.expandable,
    symbol = _ref.symbol,
    rows = _ref.rows,
    suffix = _ref.suffix;
  var Paragraph = _lib.Typography.Paragraph,
    Text = _lib.Typography.Text;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Paragraph, {
    ellipsis: ellipsis ? {
      rows: rows,
      expandable: expandable,
      symbol: symbol
    } : false,
    type: type && type,
    rows: rows,
    disabled: disabled,
    mark: mark,
    code: code,
    keyboard: keyboard,
    underline: underline,
    strong: strong,
    italic: italic,
    "delete": deletep,
    editable: editable,
    copyable: copyable,
    suffix: suffix
  }, label), /*#__PURE__*/_react["default"].createElement(Text, {
    style: ellipsis ? {
      width: 100
    } : undefined,
    ellipsis: ellipsis ? {
      tooltip: "I am ellipsis now!"
    } : false,
    suffix: suffix ? {
      tooltip: "I am suffix now!"
    } : false
  }, "Ant Design, a design language for background applications, is refined by Ant UED Team."));
};
var _default = ArcEllipsis;
exports["default"] = _default;